import { InputAdornment, TextField, Typography } from '@material-ui/core';
import { User } from 'lucide-react';
import React, { useState } from 'react';
import { CustomInputLabel } from '../../../components/CustomInputLabel';
import { FlexContainer } from '../../../layout/Flex';
import { Section } from '../../../layout/Section';

const DEFAULTPPU = 24;
const DEFAULTUSERS = 500;
const DEFAULTDISCOUNT = 0;

const TIERS = [
  { count: 1000, discount: 0 }, // no discount for 1st 1000
  { count: 1000, discount: 0.1 }, // 10% for 1001-2000
  { count: 1000, discount: 0.2 }, // 20% for 2001-3000
  { count: 1000, discount: 0.3 }, // 30% for 3001-4000
  { count: 1000, discount: 0.4 }, // 40% for 4001-5000
  // { count: 1000, discount: 0.5 }, // 50% for 5001-6000
  // { count: 1000, discount: 0.6 }, // 60% for 6001-7000
  // { count: 1000, discount: 0.7 }, // 70% for 7001-8000
  // { count: 1000, discount: 0.8 }, // 80% for 8001-9000
  { count: Infinity, discount: 0.4 } //90% for 9001+
];

function formatPrice(value: any) {
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value);
}

function calculateTotalPrice(userCount: number, basePrice: number) {
  var price = userCount * basePrice;
  return price;
}

function calculateFinalPrice(userCount: number, basePrice: number) {
  var minPrice = 5000;
  var price = 0;
  var remainingUsers = userCount;
  for (var _i = 0, TIERS_1 = TIERS; _i < TIERS_1.length; _i++) {
    var tier = TIERS_1[_i];
    var countForTier = Math.min(remainingUsers, tier.count);
    price += countForTier * basePrice * (1 - tier.discount);
    remainingUsers -= countForTier;
  }
  if (price < minPrice) {
    return minPrice;
  }
  return price;
}

export const PagePricing = () => {
  const [userCount, setUserCount] = useState(DEFAULTUSERS);
  const [basePrice, setBasePrice] = useState(DEFAULTPPU);
  const [discount, setDiscount] = useState(DEFAULTDISCOUNT);

  return (
    <Section>
      <FlexContainer spacing={2} style={{ marginBottom: '32px' }}>
        <CustomInputLabel label="Price Per Unit">
          <TextField
            type="number"
            value={basePrice}
            onChange={(e) => setBasePrice(+e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              )
            }}
          ></TextField>
        </CustomInputLabel>
        <CustomInputLabel label="Number of users">
          <TextField
            type="number"
            value={userCount}
            onChange={(e) => setUserCount(+e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <User size={16} color="#666" strokeWidth={1} />
                </InputAdornment>
              )
            }}
          ></TextField>
        </CustomInputLabel>
        <CustomInputLabel label="Additional Discount">
          <TextField
            type="number"
            value={discount}
            onChange={(e) => setDiscount(+e.target.value)}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>
            }}
          ></TextField>
        </CustomInputLabel>
      </FlexContainer>

      <FlexContainer style={{ marginBottom: '32px' }}>
        <CustomInputLabel label="Raw Price">
          <Typography component="h2" variant="h2">
            {formatPrice(calculateTotalPrice(userCount, basePrice))}
          </Typography>
        </CustomInputLabel>
      </FlexContainer>
      <FlexContainer>
        <CustomInputLabel
          label="Final Price"
          subLabel="Including Minimum Price and Discount"
        >
          <Typography component="h1" variant="h1">
            {formatPrice(
              calculateFinalPrice(userCount, basePrice) -
                calculateFinalPrice(userCount, basePrice) * (discount / 100)
            )}
          </Typography>
        </CustomInputLabel>
      </FlexContainer>
    </Section>
  );
};
